import { memo } from 'react';
import { ActivityIndicator, StyleSheet, View, ViewStyle } from 'react-native';

const styles: ViewStyle = {
  flex: 1,
  justifyContent: 'center',
  alignItems: 'center',
  backgroundColor: '#121212',
};

// This is meant to be used above the theme provider
function RawSplashScreen() {
  return (
    <View style={[StyleSheet.absoluteFill, styles]}>
      <ActivityIndicator />
    </View>
  );
}

export default memo(RawSplashScreen);
